import axios from "axios";
import { APP_CONST, getStoredItem } from "../store/dataStore";
import { responseInterceptor } from "./interceptors";
import { get } from "lodash";

const axiosInstance = axios.create({
  baseURL: window.env ? window.env.REACT_APP_BACKEND_URL : "",
});

axiosInstance.defaults.headers.common.Authorization = `Bearer ${getStoredItem(
  APP_CONST.SEC_TOKEN,
)}`;
axiosInstance.defaults.headers.common.Accept = "application/json";
axiosInstance.defaults.headers.common["Content-Type"] = "application/json";
axiosInstance.interceptors.response.use(responseInterceptor);

export const errorHandler = error => {
  const { data = {} } = error.response || {};

  if (data.message) {
    error.message = data.message;
  }

  if (data.detail) {
    error.detail = data.detail;
  }

  const errorText = get(data, "status.error");
  const messageText = get(data, "status.message");

  if (errorText) {
    error.message = errorText;
  }

  if (messageText) {
    error.title = messageText;
  }

  throw error;
};

export function totalAccountsBranchTypeAdapter(givenBranch) {
  switch (givenBranch) {
    case "DIRECT_ACCOUNT":
      return "BRANCH";
    case "INDIRECT_ACCOUNT":
      return "CUSTOMER";
    default:
      return "ALL";
  }
}

export default axiosInstance;
